import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Icon } from 'leaflet';
import GameContentProvider from '../providers/GameContentProvider';
import { useLocation } from 'react-router-dom';
import "./GameOverview.css";
import { useTranslation } from 'react-i18next';
import SurveyComponent from '../SurveyComponent';
import Toggle from '../Toggle';
import moment from 'moment';

// Component to dynamically update map center and zoom
const UpdateMapCenter = ({ center, zoom }) => {
    const map = useMap();
    map.setView(center, zoom);
    return null;
};

const GameOverview = () => {
    const { t, i18n } = useTranslation();
    const [gameId, setGameId] = useState(null);
    const [playId, setPlayId] = useState(null);
    const [history, setHistory] = useState(null);
    const [recommendations, setRecommendations] = useState(null);
    const [mapCenter, setMapCenter] = useState([42.6977, 23.3219]);
    const [mapZoom, setMapZoom] = useState(14);
    const [showSurvey, setShowSurvey] = useState(false);
    const [surveySubmitted, setSurveySubmited] = useState(false);
    const [showRecommendations, setShowRecommendations] = useState(false);
    const location = useLocation();
    const gameContentProvider = new GameContentProvider();
    const markersRef = useRef(null);

    const greenIcon = new Icon({
        iconUrl: '/assets/marker-green.png',
        iconSize: [35, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
    });

    const redIcon = new Icon({
        iconUrl: '/assets/marker.png',
        iconSize: [35, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
    });

    useEffect(() => {
        const { game, play_id } = location.state || {};
        if (game) setGameId(game);
        if (play_id) setPlayId(play_id);
    }, [location.state]);

    useEffect(() => {
        const fetchData = async () => {
            if (!gameId) return;
            try {
                let token = localStorage.getItem('token') || localStorage.getItem('guest_token');
                const result = await gameContentProvider.checkSurveySubmited(token, gameId);
                setSurveySubmited(result?.success || false);
            } catch (error) {
                console.error('Error fetching survey status:', error);
            }
        };
        fetchData();
    }, [gameId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let token = localStorage.getItem('token') || localStorage.getItem('guest_token');
                const result = await gameContentProvider.getPlayHistory(playId, token, i18n.language);
                if (result?.history?.steps?.length) {
                    setHistory(result.history);
                    setRecommendations(result.history.recommendations);
                    const firstStep = result.history.steps[0];
                    if (firstStep.latitude && firstStep.longitude) {
                        setMapCenter([firstStep.latitude, firstStep.longitude]);
                        setMapZoom(14);
                    }
                }
            } catch (error) {
                console.error('Error fetching history:', error);
            }
        };
        if (gameId && playId) fetchData();
    }, [gameId, playId]);

    const icons = {
        1: new Icon({ iconUrl: '/assets/marker_grab_and_go.png', iconSize: [35, 50] }),
        2: new Icon({ iconUrl: '/assets/marker_restaurants2.png', iconSize: [35, 50] }),
        3: new Icon({ iconUrl: '/assets/marker_games.png', iconSize: [35, 50] }),
        4: new Icon({ iconUrl: '/assets/marker_information.png', iconSize: [35, 50] }),
        5: new Icon({ iconUrl: '/assets/marker_bar.png', iconSize: [35, 50] }),
    };

    const renderMarkers = () => {
        if (!history?.steps) return null;
        return history.steps.map((step, index) => (
            step.latitude && step.longitude ? (
                <Marker key={index} position={[step.latitude, step.longitude]} icon={getMarkerIcon(step.completion_date)}>
                    <Popup>
                        <div>
                            <h4>{t('gameoverview.step')}: {step.step}</h4>
                            <p>{step.explanation}</p>
                            {step.completion_date.trim() !== "Not Completed" && (
                                <p>{t('gameoverview.step_completed')} {step.completion_date}</p>
                            )}
                        </div>
                    </Popup>
                </Marker>
            ) : null
        ));
    };

    const renderRecommendationMarkers = () => {
        if (!recommendations || !showRecommendations) return null;
        return recommendations.map((rec, index) => (
            <Marker key={`rec-${index}`} position={[rec.latitude, rec.longitude]} icon={icons[rec.type] || icons[1]}>
                <Popup>
                    <b>{rec.name}</b><br />{rec.description}
                </Popup>
            </Marker>
        ));
    };

    const getMarkerIcon = (completionDate) => {
        return completionDate !== "Not Completed" ? greenIcon : redIcon;
    };

    return (
        <div>
            {history && <h2 style={{ textAlign: 'center' }}>{t('good_job')} {history.team_name}!</h2>}
            {history && <h3 style={{ textAlign: 'center' }}>{t('game_started_at')} {moment(history.start_date).format('YYYY-MM-DD HH:mm')}</h3>}
            <div className="map-container">
                <MapContainer style={{ height: '400px', width: '90%', margin: '0 auto' }}>
                    <UpdateMapCenter center={mapCenter} zoom={mapZoom} />
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    {renderMarkers()}
                    {renderRecommendationMarkers()}
                </MapContainer>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px' }}>
                <span style={{ marginRight: '10px' }}>{t('show_recommendations')}</span>
                <Toggle checked={showRecommendations} onChange={setShowRecommendations} />
            </div>
                {!surveySubmitted && (<button onClick={() => setShowSurvey(true)}>{t('Start 1 min Survey')}</button>)}
                {showSurvey && (
                    <div className='overlay-survey'>
                        <SurveyComponent
          gameId={gameId}
          onSubmit={() => {
            setShowSurvey(false);
            setSurveySubmited(true); // Hide button after submission
          }}
        />
                    </div>
                )}
            </div>
            
        </div>
    );
};

export default GameOverview;